import { Text } from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import FilterRow, { FilterGroup } from '../../reusable/Layout';
import TextInput from '../../reusable/TextInput/TextInput';

const AthleteRegisterInfo = ({ onFilterValueChange, translations }) => {
  const { athleteLoginNumber, registerNumber } = useSelector((state) => state.nposFilters);

  return (
    <FilterGroup>
      <FilterRow>
        <Text className="filter-name">{translations.RL_AthleteRegisterInfo}</Text>
        <div className="d-sm-flx flx-dir-sm-r" style={{ gap: '12px' }}>
          <TextInput
            data-testid="athlete-register-email-input"
            id="athleteLoginNumber"
            label={translations.RL_AthleteLogin}
            placeholder={translations.RL_AthleteLogin}
            style={{ minWidth: '250px' }}
            value={athleteLoginNumber}
            onChange={onFilterValueChange}
            onClear={() => onFilterValueChange({ target: { id: 'athleteLoginNumber', value: '' } })}
          />
          <TextInput
            data-testid="athlete-register-phone-input"
            id="registerNumber"
            label={translations.RL_RegisterNo}
            placeholder={translations.RL_RegisterNo}
            style={{ minWidth: '250px' }}
            value={registerNumber}
            onChange={onFilterValueChange}
            onClear={() => onFilterValueChange({ target: { id: 'registerNumber', value: '' } })}
          />
        </div>
      </FilterRow>
    </FilterGroup>
  );
};

AthleteRegisterInfo.propTypes = {
  onFilterValueChange: PropTypes.func.isRequired,
  translations: PropTypes.shape().isRequired,
};

export default AthleteRegisterInfo;
